<template>
  <div>
    <div style="display: flex;flex-direction: column;align-items: center;padding: 15px 15px 0px 15px;background: #f4f4f4;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="/">{{$t("index.homepage")}}</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span>{{$t("index.aboutus")}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <h1 style="color: #5d84b3;border-bottom: 4px solid;padding-bottom: 10px;margin-bottom: 0;">{{musicianData[cmsIndex].cmsArticleDto.titleZhTwEn.split(',')[$store.state.i18nVal]}}</h1>
    </div>
      <el-row class="hidden-md-and-down">
        <!-- 音乐家 -->
        <div class="container">
          <el-col class="musiciancontainer" :span="24">
            <el-tabs tab-position="left" style="height: 100%;"  @tab-click="tabClick">
              <el-tab-pane v-for="(item,index) in musicianData" :key="item.id" :label="item.cmsArticleDto.titleZhTwEn.split(',')[$store.state.i18nVal]">
                <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                  <div v-if="item.children && item.children.length===0" style="width: 100%;">
                    <div v-if="$store.state.i18nVal ===0" v-html="item.cmsArticleDto.contentZh"></div>
                    <div v-if="$store.state.i18nVal ===1" v-html="item.cmsArticleDto.contentTw"></div>
                    <div v-if="$store.state.i18nVal ===2" v-html="item.cmsArticleDto.contentEn"></div>
                  </div>
                  <div v-else style="width: 100%;display: flex;justify-content:space-around">
                    <div style="width: 30%;margin-bottom: 10px;">
                      <div style="position: relative;height: 100%;">
                        <img :src="$url+item.cmsArticleDto.coverImg" style="width: 100%;height: 100%;object-fit:cover"/>
                        <!-- <div style="position: absolute;inset: 0;padding-left: 1.3em;padding-right: 0.6em;margin-top: 17em;width: 100%;height: 130px;">
                          <span style="font-weight: 600;font-size: 1.875em;color: white;">{{item.cmsArticleDto.titleZhTwEn.split(',')[$store.state.i18nVal]}}</span>
                        </div>  -->
                      </div>
                    </div>
                    <div v-for="(childrenitem,index1) in item.children" :key="index1" style="width: 30%;margin-bottom: 10px;">
                      <el-card shadow="hover" :body-style="{ padding: '0px' }" @click.native="openClick(childrenitem)">
                        <img :src="$url+childrenitem.cmsArticleDto.coverImg" class="image"/>
                        <div style="padding: 14px;">
                          <span style="font-weight: 700;">{{childrenitem.cmsArticleDto.titleZhTwEn.split(',')[$store.state.i18nVal]}}</span>
                          <div class="bottom">
                            <span class="time">{{childrenitem.cmsArticleDto.subTitleZhTwEn.split(',')[$store.state.i18nVal]}}</span>
                          </div>
                        </div>
                      </el-card>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </div>
      </el-row>
       <!-- 音乐家 --><!--≤992px 响应式栅格数或者栅格属性对象-->
      <div class="hidden-md-and-up">
          <div class="musiciancontainer">
            <el-select v-model="optionvalue" @change="(data)=>{
              cmsIndex = data
            }" placeholder="请选择" style="width: 100%;margin-bottom: 10px;">
              <el-option
                v-for="(item,index) in musicianData"
                :key="item.id"
                :label="item.cmsArticleDto.titleZhTwEn.split(',')[$store.state.i18nVal]"
                :value="index">
              </el-option>
            </el-select>
            <div v-if="musicianData[optionvalue].children && musicianData[optionvalue].children.length===0" style="width: 100%;">
              <div v-if="$store.state.i18nVal ===0" v-html="musicianData[optionvalue].cmsArticleDto.contentZh"></div>
              <div v-if="$store.state.i18nVal ===1" v-html="musicianData[optionvalue].cmsArticleDto.contentTw"></div>
              <div v-if="$store.state.i18nVal ===2" v-html="musicianData[optionvalue].cmsArticleDto.contentEn"></div>
            </div>
            <div v-else class="card_wrap">
              <div class="c_item">
                <div style="position: relative;height: 100%;">
                  <img :src="$url+musicianData[optionvalue].cmsArticleDto.coverImg" style="width: 100%;height: 100%;object-fit:cover"/>
                </div>
              </div>
              <div v-for="(childrenitem,index1) in musicianData[optionvalue].children" :key="index1" class="c_item">
                <el-card shadow="hover" :body-style="{ padding: '0px' }" @click.native="openClick(childrenitem)">
                  <img :src="$url+childrenitem.cmsArticleDto.coverImg" class="image"/>
                  <div style="padding: 14px;">
                    <span style="font-weight: 700;">{{childrenitem.cmsArticleDto.titleZhTwEn.split(',')[$store.state.i18nVal]}}</span>
                    <div class="bottom">
                      <span class="time">{{childrenitem.cmsArticleDto.subTitleZhTwEn.split(',')[$store.state.i18nVal]}}</span>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
      return{
        musicianData:[],
        optionvalue:0,
        selectvalue:null,
        cmsIndex:0,
      }
    },
    created(){
          this.getIndexData()
    },
    methods: {
      getIndexData()
      {
          this.$http({
              method: 'get',
              baseURL: this.$baseURL,
              url: '/api/Index/getmusician',
              withCredentials: true,
              params:{
                type:'musician',
                pcode:JSON.parse(decodeURI(this.$route.params.pcode)).pcode
              }
          }).then(response=>{
              this.musicianData = response.data
          })
      },
      tabClick(data)
      {
        this.cmsIndex = data.index
      },
      openClick(data)
      {
        if(data.children && data.children.length>0){
          let param = {
                code:data.code,
                levels:data.levels,
                id:data.id
            }
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            this.$router.push({path:`/list/${param}`});
          } else{
               let param = {id:data.id,}
               param = encodeURI(JSON.stringify(param))
               param = encodeURI(param)
               this.$router.push({path:`/container/${param}`});
          }
      },
      setHtml(data)
      {
        if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)===null)
        {
           if(this.$i18n.locale==='zh')
            {
                this.indexHtml = data.cmsArticleDto.contentZh
            }else if(this.$i18n.locale==='tw')
            {
                this.indexHtml = data.cmsArticleDto.contentTw
            }else{
                this.indexHtml = data.cmsArticleDto.contentEn
            }
        }else{
            if(this.$i18n.locale==='zh')
            {
                this.indexHtml = this.formatRichText(data.cmsArticleDto.contentZh)
            }else if(this.$i18n.locale==='tw')
            {
                this.indexHtml = this.formatRichText(data.cmsArticleDto.contentTw)
            }else{
                this.indexHtml = this.formatRichText(data.cmsArticleDto.contentEn)
            }
        }
      },
      formatRichText(html){
              let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
              match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
              match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
              match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
              return match;
          });
          newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
              match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
              return match;
          });
          newContent = newContent.replace(/<br[^>]*\/>/gi, '');
          newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;"');  
          return newContent;
      },
    }
  }
</script>

<style lang="scss">
.card_wrap { 
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; 
}
.c_item { 
    flex: 1;
    height: 100%;
    margin: 0 5px 5px 0; 
    width: calc((100% - 10px) / 3);  
    min-width: calc((100% - 10px) / 3); 
    max-width: calc((100% - 10px) / 3); 
    &:nth-child(3n) { 
      margin-right: 0;
    }
 }

.musiciancontainer{
  margin: 20px 0;
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }
  .el-tabs__item{
    height: 60px;
    font-size: 1em;
    line-height: 60px;
  }
  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    height: 13rem;
    display: block;
    object-fit:cover
  }
}
</style>
  